<template>
  <div>
    <v-dialog v-model="olahDataDialog" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h6 font-weight-bold">
          {{ olahDataTitle }}
        </v-card-title>

        <v-divider class="mx-5"></v-divider>

        <v-card-text class="pb-0 mt-3">
          <v-form ref="form" v-model="valid">
            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Deskripsi
            </v-card-title>
            <v-text-field
              v-model="olahData.desc"
              outlined
              dense
              :rules="[rules.required]"
              autocomplete="off"
            ></v-text-field>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Note
            </v-card-title>
            <v-select
              placeholder="Pilih Tipe Signature"
              v-model="olahData.signature_type_id"
              dense
              outlined
              :items="dataSignatureType"
              item-text="name"
              item-value="id"
              :rules="[rules.required]"
            >
            </v-select>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Nama
            </v-card-title>
            <v-text-field
              v-model="olahData.name"
              outlined
              dense
              :rules="[rules.required]"
              autocomplete="off"
            ></v-text-field>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Jabatan
            </v-card-title>
            <v-text-field
              v-model="olahData.jabatan"
              outlined
              dense
              :rules="[rules.required]"
              autocomplete="off"
            ></v-text-field>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Gudang
            </v-card-title>
            <v-select
              placeholder="Pilih Gudang"
              v-model="olahData.gudang_id"
              dense
              outlined
              :items="dataGudang"
              item-text="name"
              item-value="id"
              :rules="[rules.required]"
            >
            </v-select>
          </v-form>
        </v-card-text>

        <v-card-actions class="pt-0 pb-5">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="#61B15A"
            style="text-transform: unset !important"
            @click="closeOlahData"
          >
            Batal
          </v-btn>
          <v-btn
            color="#61B15A"
            class="white--text"
            style="text-transform: unset !important"
            @click="checkType"
            :disabled="!valid"
            :loading="loading"
          >
            {{ olahDataBtn }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    olahDataDialog: Boolean,
    olahDataTitle: String,
    olahDataBtn: String,
    olahData: Object,
    typeAction: String,
    dataGudang: Array,
    dataSignatureType: Array,
  },
  data: () => ({
    valid: false,
    loading: false,
    rules: {
      required: (value) => !!value || "Tidak boleh kosong !!",
    },
  }),
  methods: {
    checkType() {
      this.loading = true;
      this.olahData.desc = this.olahData.desc.replace(/\b\w/g, (c) =>
        c.toUpperCase()
      );
      this.olahData.name = this.olahData.name.replace(/\b\w/g, (c) =>
        c.toUpperCase()
      );
      this.olahData.jabatan = this.olahData.jabatan.replace(/\b\w/g, (c) =>
        c.toUpperCase()
      );
      axios
        .get("v1/admin/signature_type?id=" + this.olahData.signature_type_id)
        .then((response) => {
          this.olahData.note = response.data.data.name;
          if (this.typeAction === "edit") {
            this.edit();
          } else if (this.typeAction === "new") {
            this.new();
          }
        });
    },
    new() {
      const data = JSON.stringify(this.olahData);
      console.log(data);
      axios
        .post("v1/admin/signature", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(() => {
          this.loading = false;
          this.$emit("reloadData");
          this.closeOlahData();
        })
        .catch((error) => {
          if (error.response) {
            this.loading = false;
            console(error.response);
          }
        });
    },
    edit() {
      const data = JSON.stringify(this.olahData);
      axios
        .put("v1/admin/signature", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status === 201) {
            this.loading = false;
            this.$emit("reloadData");
            this.closeOlahData();
          }
        })
        .catch((error) => {
          if (error.response) {
            this.loading = false;
            console(error.response);
          }
        });
    },
    closeOlahData() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$emit("closeOlahDataDialog");
    },
  },
};
</script>